import { Layout } from '@loadsmart/miranda-react'

import { getAwardedConfirmationLanes, type Proposal } from '../domain/Proposal'
import { AwardedProposalConfirmationSection } from './AwardedProposalConfirmationSection'

type AwardedProposalConfirmationLanesListProps = {
  rfpId: string
  awardedProposal: Proposal
}

export function AwardedProposalConfirmationLanesList({
  rfpId,
  awardedProposal,
}: AwardedProposalConfirmationLanesListProps): JSX.Element {
  const { acceptedLanes, rejectedLanes } = getAwardedConfirmationLanes(awardedProposal)
  const { distanceUnit, currency } = awardedProposal.rfp

  return (
    <Layout.Stack paddingT="spacing-4">
      {acceptedLanes.length > 0 && (
        <AwardedProposalConfirmationSection
          rfpId={rfpId}
          lanes={acceptedLanes}
          title="Accepted awards:"
          distanceUnit={distanceUnit}
          currency={currency}
        />
      )}
      {rejectedLanes.length > 0 && (
        <AwardedProposalConfirmationSection
          rfpId={rfpId}
          lanes={rejectedLanes}
          title="Rejected awards:"
          distanceUnit={distanceUnit}
          currency={currency}
        />
      )}
    </Layout.Stack>
  )
}
